class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      setTimeout(function () {
        $('#carto .total-price ').load(document.URL + ' #carto .total-price>*', function () {
          setTimeout(function () {
            if (
              typeof BOLD === 'object' &&
              BOLD.common &&
              BOLD.common.eventEmitter &&
              typeof BOLD.common.eventEmitter.emit === 'function'
            ) {
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
          }, 500);
        });
        $('#shopify-section-desky-cart-main-slider .side-cart-button').load(
          document.URL + ' #shopify-section-desky-cart-main-slider .side-cart-button>*',
          function () {
            setTimeout(function () {
              if (
                typeof BOLD === 'object' &&
                BOLD.common &&
                BOLD.common.eventEmitter &&
                typeof BOLD.common.eventEmitter.emit === 'function'
              ) {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
              }
            }, 200);
          }
        );
      }, 1500);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    log.debug('tyfee');
    setTimeout(function () {
      $('#carto .total-price ').load(document.URL + ' #carto .total-price>*', function () {
        setTimeout(function () {
          if (
            typeof BOLD === 'object' &&
            BOLD.common &&
            BOLD.common.eventEmitter &&
            typeof BOLD.common.eventEmitter.emit === 'function'
          ) {
            BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
          }
        }, 500);
      });
      $('#shopify-section-desky-cart-main-slider .side-cart-button').load(
        document.URL + ' #shopify-section-desky-cart-main-slider .side-cart-button>*',
        function () {
          setTimeout(function () {
            if (
              typeof BOLD === 'object' &&
              BOLD.common &&
              BOLD.common.eventEmitter &&
              typeof BOLD.common.eventEmitter.emit === 'function'
            ) {
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
            }
          }, 200);
        }
      );
    }, 1500);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        // document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        let self = this;
        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        self.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        self.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        //document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
    setTimeout(function () {
      log.debug('yussp1');
      $('.desky-cart-payment-slider').load(document.URL + ' .desky-cart-payment-slider > *');
      if (
        typeof BOLD === 'object' &&
        BOLD.common &&
        BOLD.common.eventEmitter &&
        typeof BOLD.common.eventEmitter.emit === 'function'
      ) {
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    }, 2000);
    // setTimeout(function(){
    //   log.debug('yussp');
    //   if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
    //     BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
    //   }
    // }, 500);
  }

  updateLiveRegions(line, itemCount) {
    // if (this.currentItemCount === itemCount) {
    //   document.getElementById(`Line-item-error-${line}`)
    //     .querySelector('.cart-item__error-text')
    //     .innerHTML = window.cartStrings.quantityError.replace(
    //       '[quantity]',
    //       document.getElementById(`Quantity-${line}`).value
    //     );
    // }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    log.debug(line);
    log.debug(this.querySelectorAll('.loading-overlay'));
    log.debug(this);
    this.querySelector(`#CartItem-${line} .loading-overlay`).classList.remove('hidden');
    //this.querySelectorAll('.loading-overlay')[line-1].classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'change',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 100)
    );
  }
}

customElements.define('cart-note', CartNote);
